import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class GameStageService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getGameStageList(gameId, page, size, title, status) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `games/${gameId}/stages`,
                {
                    page,
                    size,
                    "title": title && title.length > 0 ? title : null,
                    "status": status && status !== "ALL" && status.length > 0 ? status : null
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewGameStage(gameId, title, scoreWeight, maxScore) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `games/${gameId}/stages`,
                {
                    title,
                    scoreWeight,
                    maxScore,
                }
            ).then(resolve).catch(reject)
        })
    }

    getGameStageInfo(gameStageId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-stages/${gameStageId}/information`
            ).then(resolve).catch(reject)
        })
    }

    updateGameStageInfo(gameStageId, title) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `game-stages/${gameStageId}/information`,
                {},
                {
                    title
                }
            ).then(resolve).catch(reject)
        })
    }

    getGameStageDescription(gameStageId) {
        const gameStageContentState = this.httpClient.get(
            `game-stages/${gameStageId}/description`
        );
        const requests = [
            gameStageContentState
        ]
        return new Promise((resolve, reject) => {
            axios.all(requests)
                .then(axios.spread((gameStageContent) => {
                        resolve({
                            gameStageContent
                        })
                    })
                ).catch(reject)
        })
    }

    updateGameStageDescription(gameStageId, contents) {
        const _content = []
        contents.map((item, index) => {
            _content.push({
                ...item,
                priority: index
            })
        })

        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `game-stages/${gameStageId}/description`,
                {},
                _content
            ).then(resolve).catch(reject)
        })

    }

    getGameStageSettings(gameStageId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-stages/${gameStageId}/settings`
            ).then(resolve).catch(reject)
        })
    }

    updateGameStageSettings(gameStageId, scoreWeight, maxScore) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `game-stages/${gameStageId}/settings`,
                {},
                {
                    scoreWeight,
                    maxScore
                }
            ).then(resolve).catch(reject)
        })
    }

    getGameStageStatus(gameStageId){
        return new Promise((resolve, reject)=>{
            this.httpClient.get(
                `game-stages/${gameStageId}/admission-settings`
            ).then(resolve).catch(reject)
        })
    }

    updateGameStageStatus(gameStageId,status){
        return new Promise((resolve, reject)=>{
            this.httpClient.patch(
                `game-stages/${gameStageId}/admission-settings`,
                {},
                {
                    status
                }
            ).then(resolve).catch(reject)
        })
    }
}